<section
  class="retention-policy-step-control-panel"
  [class.for-schedule]="placement() === 'schedule'">
  @if (isAlertMode()) {
    <ng-container *ngTemplateOutlet="alertBlock"></ng-container>
  } @else if (isHybridMode()) {
    <ng-container *ngTemplateOutlet="hybridBlock"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="retentionBlock"></ng-container>
  }

  <section [formGroup]="parentForm()">
    <ng-template #retentionBlock>
      <mbs-card-group class="-sm">
        <ng-container *ngTemplateOutlet="retentionPeriod"></ng-container>
      </mbs-card-group>
      @if (isWindows() && (isAdvancedMode() || forceGFSShow())) {
        <mbs-card-group class="-sm">
          <ng-container *ngTemplateOutlet="GFSBlock"></ng-container>
        </mbs-card-group>
      }
    </ng-template>

    <ng-template #retentionPeriod>
      <div class="row justify-content-between ml-n1">
        <div class="col-auto flex-grow-1">
          @if (!isCompactLayout()) {
            <div class="d-flex align-items-center m-0 mb-2">
              <ng-container *ngTemplateOutlet="retentionPeriodTitle"></ng-container>
            </div>
          }
          <div class="form-row align-items-center ml-n1">
            @if (isCompactLayout()) {
              <div class="col-auto">
                <ng-container *ngTemplateOutlet="retentionPeriodTitle"></ng-container>
              </div>
            }
            <div class="col-2">
              <mbs-number
                formControlName="deleteVersionsOlderThanCount"
                [id]="elementSelectors.id.simpleBlockCount"
                [isErrorsShow]="false"
                [min]="1"
                (change)="retentionChange.emit()"></mbs-number>
            </div>
            <div class="col-3">
              <mbs-select
                formControlName="deleteVersionsOlderThanPeriod"
                [appendTo]="'.modal-content'"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [id]="elementSelectors.id.simpleBlockPeriod"
                [items]="periodEnumSelectArray"
                [searchable]="false"
                (change)="retentionChange.emit()"></mbs-select>
            </div>
          </div>
          @if (parentForm()?.get('deleteVersionsOlderThanCount')?.errors?.minHybridError) {
            <div class="d-flex align-items-center ml-n1">
              <mbs-input-errors [errors]="[{ message: ('wizards:retention.retentionHybridErrorMin' | i18next) }]"></mbs-input-errors>
            </div>
          }
        </div>
        <div class="col-auto d-flex align-items-center">
          @if (!isSimpleMode()) {
            <mbs-switcher
              [attr.data-e2e]="elementSelectors.id.simpleBlockSwitcher"
              [selected]="!parentForm().get('RetentionUseDefaultSettings').value"
              (change)="retentionUseDefaultSettingsChange.emit()">
            </mbs-switcher>
          }
        </div>
      </div>
      <div class="d-flex align-items-center m-0 mt-1">
        @if (isSimpleMode()) {
          <mbs-input-errors [errors]="[{ message: $any(alerts()?.keepBackupFFIAlert) }]"></mbs-input-errors>
        }
        <mbs-input-errors [errors]="[{ message: $any(alerts()?.keepBackupStorageObjectLockAlert) }]"></mbs-input-errors>
      </div>
      <div class="retention-policy-step-control-panel_alerts">
        <ng-container *ngTemplateOutlet="alertBlock"></ng-container>
      </div>
    </ng-template>

    <ng-template #retentionPeriodTitle>
      <strong>{{ 'wizards:retention.retentionPeriod' | i18next }}</strong>
      @if (isSimpleMode() || isAdvancedMode()) {
        <span
          class="fa fa-info-circle ml-2 cursor-help text-info"
          container="body"
          tooltipClass="tooltip-xl"
          [ngbTooltip]="retentionPeriodTooltip"
          [placement]="'right'"></span>
      }
      <ng-template #retentionPeriodTooltip>
        @if (isSimpleMode()) {
          <div>{{ 'wizards:retention.simpleSchedule.retentionPeriodTooltip' | i18next }}</div>
        }
        @if (isAdvancedMode()) {
          <div>{{ 'wizards:retention.advancedSchedule.retentionPeriodTooltip' | i18next }}</div>
        }
      </ng-template>
    </ng-template>

    <ng-template #GFSBlock>
      <div
        class="row ml-n1"
        [attr.data-e2e]="elementSelectors.id.GFSBlock">
        <div class="col-11">
          <div class="d-flex align-items-center">
            <strong
              class="ml-0"
              [class.text-muted]="parentForm().get('RetentionUseDefaultSettings').value">
              {{ 'wizards:retention.advancedSchedule.titleGFS' | i18next }}
            </strong>
            <span
              class="fa fa-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-xl"
              [ngbTooltip]="'wizards:retention.advancedSchedule.titleGFSTooltip' | i18next"
              [placement]="'right'"></span>
          </div>
          <mbs-button
            class="m-0 _hover-parent"
            type="link"
            [customClasses]="'pl-0'"
            [disabled]="
              parentForm().get('RetentionUseDefaultSettings').value || !parentForm().get('GFSPolicySettings').get('enabled').value
            "
            [id]="elementSelectors.id.buttonGFS"
            (click)="clickDetailsGFS.emit()">
            <div class="col-auto mt-1">
              <div
                *ngFor="let info of GFSInfo(); let i = index"
                class="d-flex align-items-center">
                {{ info }}
                <span
                  *ngIf="!i"
                  class="_hover-target fa fa-pencil ml-2 mt-1"></span>
              </div>
              <div
                *ngIf="!GFSInfo()"
                class="d-flex align-items-center">
                {{ 'shared:common.disabled' | i18next: { format: 'title' } }}
              </div>
            </div>
          </mbs-button>
        </div>
        <div class="col-1 d-flex align-items-center">
          <mbs-switcher
            [disabledSelf]="parentForm().get('RetentionUseDefaultSettings').value || isHybrid()"
            [id]="elementSelectors.id.switcherGFS"
            [selected]="parentForm().get('GFSPolicySettings').get('enabled').value"
            (beforeUpdate)="beforeGFSEnabledChange.emit($event)"
            (change)="GFSEnabledChange.emit()">
          </mbs-switcher>
        </div>
      </div>
    </ng-template>

    <ng-template #alertBlock>
      @if (alertsCount().total) {
        <mbs-button
          [attr.data-e2e]="alertsExpanded() ? null : elementSelectors.id.alertExpandButton"
          [customClasses]="'pl-0'"
          [type]="'link'"
          (click)="alertsExpanded.set(!alertsExpanded())">
          @if (alertsExpanded()) {
            <span>{{ 'wizards:retention.hideAlerts' | i18next }}</span>
          } @else {
            <span>{{ 'wizards:retention.showAlerts' | i18next }}:</span>
            @if (alertsCount().danger) {
              <span>{{ alertsCount().danger }}</span>
              <span
                class="ms-n1 text-danger"
                [ngClass]="MbsPopupIcon.danger"></span>
            }
            @if (alertsCount().warning) {
              <span>{{ alertsCount().warning }}</span>
              <span
                class="ms-n1 text-warning"
                [ngClass]="MbsPopupIcon.warning"></span>
            }
            @if (alertsCount().info) {
              <span>{{ alertsCount().info }}</span>
              <span
                class="ms-n1 text-info"
                [ngClass]="MbsPopupIcon.info"></span>
            }
          }
        </mbs-button>
      }

      @if (alertsExpanded()) {
        @if (isSimpleMode() && storage().minPeriod && !isTemplateWizard) {
          <div
            class="d-flex align-items-center m-0 mt-4"
            [id]="elementSelectors.id.simpleBlockMinPeriodAlert">
            <mbs-alert
              class="mb-0"
              [icon]="true"
              [type]="MbsPopupType.info">
              <strong>
                {{ 'wizards:retention.simpleSchedule.minPeriodAlertTitle' | i18next: { name: storage().name } }}
              </strong>
              <div class="mt-1">
                <span
                  [innerHTML]="
                    'wizards:retention.simpleSchedule.minPeriodAlert'
                      | i18next: { name: storage().name, minPeriod: storage().minPeriod }
                      | safe: 'html'
                  "
                  (click)="alertClickHandler($event)"></span
                >.
                <a
                  class="ml-2 no-wrap"
                  target="_blank"
                  [helpLink]="'/AP/Help/backup/about/retention-policy'"
                  [kbMode]="true">
                  {{ 'shared:buttons.learnMore' | i18next }}
                </a>
              </div>
            </mbs-alert>
          </div>
        }

        @if (alerts()?.needMinPeriodAlert && isAdvancedMode()) {
          <div
            class="d-flex align-items-center m-0 mt-4"
            [id]="elementSelectors.id.simpleBlockMinPeriodAlert">
            <mbs-alert
              class="mb-0"
              [icon]="true"
              [type]="MbsPopupType.info">
              <div>
                <span
                  [innerHTML]="
                    'wizards:retention.advancedSchedule.minPeriodAdvancedAlert' | i18next: { minPeriod: storage().minPeriod } | safe: 'html'
                  "
                  (click)="alertClickHandler($event)"></span
                >.
                <a
                  class="ml-2 no-wrap"
                  target="_blank"
                  [helpLink]="'/AP/Help/backup/about/retention-policy'"
                  [kbMode]="true">
                  {{ 'shared:buttons.learnMore' | i18next }}
                </a>
              </div>
            </mbs-alert>
          </div>
        }

        @if (parentForm().get('RetentionUseDefaultSettings')?.value && !alerts()?.needRetentionForGFSAlert) {
          <div
            class="d-flex align-items-center m-0 mt-4"
            [id]="elementSelectors.id.simpleBlockRecommendTurnOn">
            <mbs-alert
              class="mb-0"
              [icon]="true"
              [type]="MbsPopupType.danger">
              <div>
                {{ 'wizards:retention.simpleSchedule.recommendTurnOn' | i18next }}
                <a
                  class="ml-2 no-wrap"
                  target="_blank"
                  [helpLink]="'/AP/Help/backup/about/retention-policy'"
                  [kbMode]="true">
                  {{ 'shared:buttons.learnMore' | i18next }}
                </a>
              </div>
            </mbs-alert>
          </div>
        }

        @if (!parentForm().get('RetentionUseDefaultSettings')?.value && alerts()?.keepBackupFullAlert) {
          <div
            class="d-flex align-items-center m-0 mt-4"
            [id]="elementSelectors.id.advancedBlockMinPeriodAlert">
            <mbs-alert
              class="mb-0"
              [icon]="true"
              [type]="MbsPopupType.warning">
              <div class="mb-2">{{ 'wizards:retention.advancedSchedule.minPeriodAlertP1' | i18next }}</div>
              @if (isWindows()) {
                <div>{{ 'wizards:retention.advancedSchedule.minPeriodAlertP2' | i18next }}</div>
              }
              <div>
                <a
                  class="no-wrap"
                  target="_blank"
                  [helpLink]="'/AP/Help/backup/file/nbf#9'"
                  [kbMode]="true">
                  {{ 'shared:buttons.learnMore' | i18next }}
                </a>
              </div>
            </mbs-alert>
          </div>
        }

        @if (alerts()?.needRetentionForGFSAlert) {
          <div
            class="d-flex align-items-center m-0 mt-4"
            [id]="elementSelectors.id.needRetentionForGFSAlert">
            <mbs-alert
              class="mb-0"
              [icon]="true"
              [type]="MbsPopupType.danger">
              {{ 'wizards:retention.advancedSchedule.needRetentionForGFSAlert' | i18next }}
            </mbs-alert>
          </div>
        }
      }
    </ng-template>

    <ng-template #hybridBlock>
      <div
        class="row justify-content-between ml-n1"
        formGroupName="HybridRetentionPolicy">
        <div class="col-auto flex-grow-1">
          <div class="d-flex align-items-center m-0 mb-2">
            <strong>{{ 'wizards:retention.retentionPeriod' | i18next }}</strong>
            <span
              *ngIf="isSimpleMode() || isAdvancedMode()"
              class="fa fa-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-xl"
              [ngbTooltip]="retentionPeriodTooltip"
              [placement]="'right'"></span>
            <ng-template #retentionPeriodTooltip>
              <div *ngIf="isSimpleMode()">{{ 'wizards:retention.simpleSchedule.retentionPeriodTooltip' | i18next }}</div>
              <div *ngIf="isAdvancedMode()">{{ 'wizards:retention.advancedSchedule.retentionPeriodTooltip' | i18next }}</div>
            </ng-template>
          </div>
          <div class="form-row align-items-center ml-n1">
            <div class="col-2">
              <mbs-number
                formControlName="deleteVersionsOlderThanCount"
                [id]="'hybrid-delete-versions-older-than-count-number'"
                [max]="10000"
                [min]="1"
                (change)="retentionHybridChange.emit()"></mbs-number>
            </div>
            <div class="col-3">
              <mbs-select
                formControlName="deleteVersionsOlderThanPeriod"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [id]="'hybrid-delete-versions-older-than-period-select'"
                [items]="periodEnumSelectArray"
                [searchable]="false"
                (change)="retentionHybridChange.emit()"></mbs-select>
            </div>
          </div>
        </div>
        <div class="col-auto d-flex align-items-center">
          @if (!isSimpleMode()) {
            <mbs-switcher
              formControlName="deleteVersionsOlderThan"
              (afterUpdate)="hubridRetentionSwitchHandler($event)">
            </mbs-switcher>
          }
        </div>
      </div>
    </ng-template>
  </section>
</section>
